import type { Article } from "../types";

interface ArticleMediaProps {
  article: Article;
  compact?: boolean;
  priority?: boolean;
  sizes?: string;
  caption?: boolean;
}

export function ArticleMedia({ article, compact = false, priority = false, sizes = "100vw", caption = true }: ArticleMediaProps) {
  if (!article.media) return null;
  const variants = article.media.variants ?? [];
  const avif = variants.filter(item => item.type === "image/avif").sort((left, right) => left.width - right.width);
  const webp = variants.filter(item => item.type === "image/webp").sort((left, right) => left.width - right.width);
  const sourceSet = (items: typeof variants) => items.map(item => `${item.url} ${item.width}w`).join(", ");

  return <figure className={`article-media ${compact ? "compact" : ""}`}>
    <picture>
      {avif.length > 0 && <source type="image/avif" srcSet={sourceSet(avif)} sizes={sizes} />}
      {webp.length > 0 && <source type="image/webp" srcSet={sourceSet(webp)} sizes={sizes} />}
      <img
        src={article.media.url}
        alt={article.media.alt}
        width={article.media.width ?? 1600}
        height={article.media.height ?? 900}
        loading={priority ? "eager" : "lazy"}
        {...(priority ? { fetchpriority: "high" } : {})}
        decoding="async"
      />
    </picture>
    {caption && <figcaption>
      <span>{article.media.label || "Ilustracja redakcyjna AI"}</span>
      {article.media.generatedAt && <time dateTime={article.media.generatedAt}>{new Date(article.media.generatedAt).toLocaleDateString("pl-PL")}</time>}
    </figcaption>}
  </figure>;
}
